var _desc, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunnySideUpEgg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sunny Side Up Egg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer2",
    cx: 28,
    cy: 37,
    r: 11,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M31 2C20.9 2 3 10.4 3 38c0 15.8 10 24 24 24 6.6 0 18-3.3 26-14s11.7-19.8 4-28S46.2 2 31 2z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunnySideUpEgg);
export default __webpack_public_path__ + "static/media/sunny-side-up-egg.e88528de.svg";
export { ForwardRef as ReactComponent };